import { FC, SyntheticEvent, type CSSProperties } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { ComboBoxComponentProps } from "../../interface";

type Option = Record<string, unknown>;

const ComboBoxComponent: FC<ComboBoxComponentProps & Record<string, any>> = (props) => {
  const {
    dataSource = [],
    fields = { text: "text", value: "value" },
    value,
    change,
    onChange,
    placeholder,
    isEnabled = true,
    widthInPercentage,
    margin,
    ...rest
  } = props;

  const options: Option[] = Array.isArray(dataSource) ? dataSource : [];
  const textField = fields?.text || "text";
  const valueField = fields?.value || "value";

  const resolvedValue: Option | string | null = (() => {
    if (value == null) return null;
    if (typeof value === "object") return value as Option;
    return options.find((o) => o[valueField] === value || o[textField] === value) ?? String(value);
  })();

  const handleChange = (_: SyntheticEvent, newValue: Option | string | null) => {
    const selectedValue =
      newValue == null ? null : typeof newValue === "string" ? newValue : (newValue[valueField] ?? newValue[textField]);
    if (change) change({ value: selectedValue, itemData: newValue });
    if (onChange) onChange({ value: selectedValue, itemData: newValue });
  };

  const containerStyle: CSSProperties = {
    width: widthInPercentage || "100%",
    margin: margin || undefined,
  };

  return (
    <div style={containerStyle}>
      <Autocomplete
        freeSolo
        options={options}
        value={resolvedValue}
        disabled={!isEnabled}
        getOptionLabel={(option: Option | string) =>
          typeof option === "string" ? option : String(option[textField] ?? "")
        }
        isOptionEqualToValue={(option: Option | string, val: Option | string) => {
          if (typeof option === "string" || typeof val === "string") return option === val;
          return option[valueField] === val[valueField];
        }}
        onChange={handleChange}
        renderInput={(params) => <TextFieldComponent {...params} placeholder={placeholder as string | undefined} />}
        {...rest}
      />
    </div>
  );
};

export default ComboBoxComponent;
